import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/FACTORY_UPLOAD`;

export const REDUCER_NAME = 'FACTORY_UPLOAD';

export const ROUTES = {
  ROOT: '/factory-upload',
};

export const MIME_TYPES = ['.pdf', '.xls', '.xlsx'];
